import { render } from "./Amin.vue?vue&type=template&id=ac036c12"
const script = {}
script.render = render

export default script